export default __webpack_public_path__ + "static/media/Legguards of Flowing Water.d055bcef.jpg";